import React, { PureComponent } from "react";
import moment from "moment";
import "./HeaderDate.scss";
import { translate } from "clavis-nxt-components-custdevtm";
import { router } from "util/routing/Routing";

class HeaderDate extends PureComponent {
  static displayName = "HeaderDate";
  constructor(props) {
    super(props);
    this.delay = 10000; // 10 sec
    this.min = 60000; // 60 sec
    this.sec = 1000; // 1 sec
    this.state = {
      date: moment().format("YYYY.MM.DD HH:mm:ss")
    };
  }

  componentDidMount() {
    this.timerID = setInterval(() => this.tick(), this.sec);
  }

  componentWillUnmount() {
    clearInterval(this.timerID);
  }

  tick() {
    this.setState({
      date: moment().format("YYYY.MM.DD HH:mm:ss")
    });
  }

  render() {
    const { t } = this.props;
    const idleTimer = this.props.idleTimer;
    let remainingTime = idleTimer.getRemainingTime();
    const delayedRemainingTime = idleTimer.props.timeout - this.delay;
    let min = parseInt(remainingTime / this.min);
    let sec = parseInt((remainingTime % this.min) / this.sec);
    return (
      remainingTime < delayedRemainingTime && (
        <div className="date-and-time">
          <i className="icon-corporateactions icon-normal" />
          <div className="date normal-font-medium ">
            {t("pls.header.countDown", { min, sec })}
          </div>
        </div>
      )
    );
  }
}

export default router(translate()(HeaderDate));
